 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		4: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"578e4c086f16b71ef67124e00c2750e2ab137bf1","5":"3f06fcd6","8":"component---src-pages-404-index-js","9":"component---src-pages-blog-index-js","10":"component---src-pages-community-index-js","11":"component---src-pages-contribute-index-js","12":"component---src-pages-evangelist-index-js","13":"component---src-pages-events-index-js","14":"component---src-pages-hackshack-arcade-index-js","15":"component---src-pages-hackshack-challenge-terms-conditions-index-js","16":"component---src-pages-hackshack-challenges-index-js","17":"component---src-pages-hackshack-challenges-template-js","18":"component---src-pages-hackshack-ezmeral-index-js","19":"component---src-pages-hackshack-hack-shack-attack-index-js","20":"component---src-pages-hackshack-hpediscover-2022-participations-terms-conditions-index-js","21":"component---src-pages-hackshack-hpediscover-2022-swchallenges-terms-conditions-index-js","22":"component---src-pages-hackshack-hpediscover-2022-treasurehunt-terms-conditions-index-js","23":"component---src-pages-hackshack-hpediscover-2023-participations-terms-conditions-index-js","24":"component---src-pages-hackshack-hpediscover-2023-treasurehunt-terms-conditions-index-js","25":"component---src-pages-hackshack-hpetss-2023-treasurehunt-terms-conditions-index-js","26":"component---src-pages-hackshack-index-js","27":"component---src-pages-hackshack-replays-index-js","28":"component---src-pages-hackshack-replays-template-js","29":"component---src-pages-hackshack-stickerwall-index-js","30":"component---src-pages-hackshack-treasurehunt-terms-conditions-index-js","31":"component---src-pages-hackshack-workshop-terms-conditions-index-js","32":"component---src-pages-hackshack-workshops-index-js","33":"component---src-pages-hackshack-workshops-template-js","34":"component---src-pages-home-index-js","35":"component---src-pages-newsletter-archive-index-js","36":"component---src-pages-newsletter-signup-index-js","37":"component---src-pages-opensource-index-js","38":"component---src-pages-os-scontribute-index-js","39":"component---src-pages-platforms-index-js","40":"component---src-pages-role-index-js","41":"component---src-pages-search-index-js","42":"component---src-pages-skillup-index-js","43":"component---src-pages-slack-signup-index-js","44":"component---src-pages-tags-index-js","45":"component---src-pages-use-cases-index-js","46":"component---src-templates-blog-post-js","47":"component---src-templates-campaign-js","48":"component---src-templates-event-js","49":"component---src-templates-newsletter-js","50":"component---src-templates-platform-js","51":"component---src-templates-role-js","52":"component---src-templates-tags-js","53":"component---src-templates-use-case-js","56":"polyfills-core-js","57":"polyfills-dom"}[chunkId]||chunkId) + "-" + {"0":"99592748317606f7a226","1":"e9d24b1846c7d6eb9685","2":"114c239179c0cb1fa56b","5":"d5954abaf299ae84d068","8":"b75b4348c57baf2d5891","9":"144c9f75d7241c85c7f5","10":"72e1e0a084ff72426bb1","11":"9993d22e034cb53534aa","12":"ab844ddf30c4fb691549","13":"4b9e6c588cdd9a3e7a0d","14":"c9eb9b1e70da2785bd25","15":"c17e45520e8801b9ef53","16":"4f126f121d82e7a97b42","17":"3443cf799808e96e4892","18":"27a5e09ff70da8752fd5","19":"ee3afb5208fb44c5c713","20":"3ef4e95034426acb5d79","21":"b7b72313ea7dadea877b","22":"b4dff205ba0969ba56a4","23":"48751fd2661c3d223cda","24":"439992bb690141405309","25":"eee750eb4cf002951916","26":"9f43df3496e7991e3e42","27":"d54ccf54c73db5dc2236","28":"9131049e3e5e01cc83f8","29":"4609069f985dcd7f1228","30":"978f63c8b491cfdec9fd","31":"1dc78fe55d523a71c0e5","32":"cc90a8c2fec6721a3dd1","33":"492b756571aba3dea76d","34":"893b989c6112ed7af127","35":"f8d9349973f34bbec108","36":"10a73438989e162b53fd","37":"f9b20d5d55f19084a6e4","38":"6181ab0f28045ffc77d8","39":"2948b7135139a063c520","40":"1f5e9508dc670b173041","41":"cea68b4573b06deaf21b","42":"7e924943f627fff8a341","43":"adaa883b2dbd26ead3ba","44":"0cb05005059b434a5c7b","45":"c3531656e70a7b1f8818","46":"dd549d7e572b5b12af62","47":"40abfab5c3b2e122e69d","48":"48db951a5bc00d4f2233","49":"6a62f95301accb491d7a","50":"f658d82ca07f2fb63d9d","51":"fa5dfe0574f84288e2ec","52":"c087d696f1cb008e56ae","53":"623ce966902f8fb5f41d","56":"a682334a29f3f194f38e","57":"efe018d40fc4038704bc","58":"af964ab9b9c0ad392f4b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"578e4c086f16b71ef67124e00c2750e2ab137bf1","5":"3f06fcd6","8":"component---src-pages-404-index-js","9":"component---src-pages-blog-index-js","10":"component---src-pages-community-index-js","11":"component---src-pages-contribute-index-js","12":"component---src-pages-evangelist-index-js","13":"component---src-pages-events-index-js","14":"component---src-pages-hackshack-arcade-index-js","15":"component---src-pages-hackshack-challenge-terms-conditions-index-js","16":"component---src-pages-hackshack-challenges-index-js","17":"component---src-pages-hackshack-challenges-template-js","18":"component---src-pages-hackshack-ezmeral-index-js","19":"component---src-pages-hackshack-hack-shack-attack-index-js","20":"component---src-pages-hackshack-hpediscover-2022-participations-terms-conditions-index-js","21":"component---src-pages-hackshack-hpediscover-2022-swchallenges-terms-conditions-index-js","22":"component---src-pages-hackshack-hpediscover-2022-treasurehunt-terms-conditions-index-js","23":"component---src-pages-hackshack-hpediscover-2023-participations-terms-conditions-index-js","24":"component---src-pages-hackshack-hpediscover-2023-treasurehunt-terms-conditions-index-js","25":"component---src-pages-hackshack-hpetss-2023-treasurehunt-terms-conditions-index-js","26":"component---src-pages-hackshack-index-js","27":"component---src-pages-hackshack-replays-index-js","28":"component---src-pages-hackshack-replays-template-js","29":"component---src-pages-hackshack-stickerwall-index-js","30":"component---src-pages-hackshack-treasurehunt-terms-conditions-index-js","31":"component---src-pages-hackshack-workshop-terms-conditions-index-js","32":"component---src-pages-hackshack-workshops-index-js","33":"component---src-pages-hackshack-workshops-template-js","34":"component---src-pages-home-index-js","35":"component---src-pages-newsletter-archive-index-js","36":"component---src-pages-newsletter-signup-index-js","37":"component---src-pages-opensource-index-js","38":"component---src-pages-os-scontribute-index-js","39":"component---src-pages-platforms-index-js","40":"component---src-pages-role-index-js","41":"component---src-pages-search-index-js","42":"component---src-pages-skillup-index-js","43":"component---src-pages-slack-signup-index-js","44":"component---src-pages-tags-index-js","45":"component---src-pages-use-cases-index-js","46":"component---src-templates-blog-post-js","47":"component---src-templates-campaign-js","48":"component---src-templates-event-js","49":"component---src-templates-newsletter-js","50":"component---src-templates-platform-js","51":"component---src-templates-role-js","52":"component---src-templates-tags-js","53":"component---src-templates-use-case-js","56":"polyfills-core-js","57":"polyfills-dom"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"0a7ec41a3857128757fa","2":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
